// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estrutura interna dos painéis flutuantes e estados de tela. */

.flutuante__cabecalho {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  padding: var(--espaco-2) var(--espaco-2) var(--espaco-2) var(--espaco-3);
  border-bottom: 1px solid var(--linha);
}

.flutuante__titulo {
  font-size: var(--texto-sm);
  font-weight: 600;
  letter-spacing: 0.01em;
}

.flutuante__acoes {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 2px;
}

.flutuante__corpo {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

/* --- Seção dentro de um painel ------------------------------------------- */

.secao {
  border-bottom: 1px solid var(--linha);
}

.secao:last-child {
  border-bottom: none;
}

.secao__rotulo {
  display: flex;
  align-items: baseline;
  gap: var(--espaco-2);
  padding: var(--espaco-3) var(--espaco-3) var(--espaco-1);
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  font-weight: 600;
}

.secao__contagem {
  margin-left: auto;
  font-family: var(--fonte-dados);
  font-weight: 400;
  font-variant-numeric: tabular-nums;
}

.secao__corpo {
  padding: var(--espaco-1) var(--espaco-3) var(--espaco-3);
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
}

.nota {
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  line-height: 1.5;
}

/* Seção recolhível, para conteúdo secundário. */
.secao__resumo {
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  padding: var(--espaco-3);
  color: var(--tinta-media);
  font-size: var(--texto-sm);
  cursor: pointer;
  list-style: none;
}

.secao__resumo::-webkit-details-marker {
  display: none;
}

.secao__resumo::before {
  content: '';
  width: 0;
  height: 0;
  border-left: 4px solid var(--tinta-suave);
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  transition: transform var(--transicao);
}

details[open] > .secao__resumo::before {
  transform: rotate(90deg);
}

/* --- Indicadores de estado ----------------------------------------------- */

.sinal {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  height: 28px;
  padding: 0 var(--espaco-2);
  background: none;
  border: 1px solid transparent;
  border-radius: var(--raio);
  color: var(--tinta-media);
  font-size: var(--texto-xs);
  white-space: nowrap;
  cursor: pointer;
  transition:
    background var(--transicao),
    border-color var(--transicao);
}

.sinal:hover:not(:disabled) {
  background: var(--papel-2);
  border-color: var(--linha);
}

.sinal:disabled {
  cursor: progress;
}

.sinal__ponto {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--tom, var(--tinta-suave));
  /* O anel garante leitura do estado sem depender apenas da cor. */
  box-shadow: 0 0 0 2px var(--halo, transparent);
}

.sinal--ok {
  --tom: var(--ok);
  --halo: color-mix(in srgb, var(--ok) 18%, transparent);
}

.sinal--alerta {
  --tom: var(--alerta);
  --halo: color-mix(in srgb, var(--alerta) 20%, transparent);
}

.sinal--erro {
  --tom: var(--erro);
  --halo: color-mix(in srgb, var(--erro) 20%, transparent);
  color: var(--erro);
}

.sinal--neutro {
  --tom: var(--linha-forte);
}

/* --- Estados de conteúdo ------------------------------------------------- */

.estado {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-1);
  padding: var(--espaco-3);
  border: 1px dashed var(--linha-forte);
  border-radius: var(--raio);
  background: var(--papel-2);
}

.estado__titulo {
  font-size: var(--texto-sm);
  font-weight: 600;
}

.estado__texto {
  color: var(--tinta-media);
  font-size: var(--texto-xs);
  line-height: 1.5;
}

.estado--erro {
  border-style: solid;
  border-color: color-mix(in srgb, var(--erro) 32%, var(--linha));
  background: color-mix(in srgb, var(--erro) 4%, var(--papel));
}

.estado--erro .estado__titulo {
  color: var(--erro);
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
}

/* --- Carregamento -------------------------------------------------------- */

.girando {
  display: inline-block;
  width: 11px;
  height: 11px;
  border: 2px solid var(--linha-forte);
  border-top-color: var(--realce);
  border-radius: 50%;
  animation: girar 700ms linear infinite;
}

@keyframes girar {
  to {
    transform: rotate(360deg);
  }
}

.carregando {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  color: var(--tinta-media);
  font-size: var(--texto-xs);
}

/* Progresso do carregamento das geometrias, uma requisição por unidade. */
.progresso {
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
}

.progresso__barra {
  flex: 1 1 auto;
  height: 2px;
  background: var(--papel-3);
  border-radius: 2px;
  overflow: hidden;
}

.progresso__preenchimento {
  display: block;
  height: 100%;
  background: var(--pena-unidade);
  transition: width var(--transicao);
}
`, "",{"version":3,"sources":["webpack://./src/styles/componentes.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wEAAwE;EACxE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA,8EAA8E;;AAE9E;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,wDAAwD;EACxD,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,iCAAiC;EACjC,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8EAA8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf;;iCAE+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,iEAAiE;EACjE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,qCAAqC;EACrC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,8EAA8E;;AAE9E;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;AACpC","sourcesContent":["/* Estrutura interna dos painéis flutuantes e estados de tela. */\r\n\r\n.flutuante__cabecalho {\r\n  flex: none;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-2) var(--espaco-2) var(--espaco-2) var(--espaco-3);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.flutuante__titulo {\r\n  font-size: var(--texto-sm);\r\n  font-weight: 600;\r\n  letter-spacing: 0.01em;\r\n}\r\n\r\n.flutuante__acoes {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.flutuante__corpo {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* --- Seção dentro de um painel ------------------------------------------- */\r\n\r\n.secao {\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.secao:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.secao__rotulo {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-3) var(--espaco-3) var(--espaco-1);\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  font-weight: 600;\r\n}\r\n\r\n.secao__contagem {\r\n  margin-left: auto;\r\n  font-family: var(--fonte-dados);\r\n  font-weight: 400;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.secao__corpo {\r\n  padding: var(--espaco-1) var(--espaco-3) var(--espaco-3);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n}\r\n\r\n.nota {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Seção recolhível, para conteúdo secundário. */\r\n.secao__resumo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-3);\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-sm);\r\n  cursor: pointer;\r\n  list-style: none;\r\n}\r\n\r\n.secao__resumo::-webkit-details-marker {\r\n  display: none;\r\n}\r\n\r\n.secao__resumo::before {\r\n  content: '';\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 4px solid var(--tinta-suave);\r\n  border-top: 4px solid transparent;\r\n  border-bottom: 4px solid transparent;\r\n  transition: transform var(--transicao);\r\n}\r\n\r\ndetails[open] > .secao__resumo::before {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n/* --- Indicadores de estado ----------------------------------------------- */\r\n\r\n.sinal {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  height: 28px;\r\n  padding: 0 var(--espaco-2);\r\n  background: none;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--raio);\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-xs);\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  transition:\r\n    background var(--transicao),\r\n    border-color var(--transicao);\r\n}\r\n\r\n.sinal:hover:not(:disabled) {\r\n  background: var(--papel-2);\r\n  border-color: var(--linha);\r\n}\r\n\r\n.sinal:disabled {\r\n  cursor: progress;\r\n}\r\n\r\n.sinal__ponto {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: var(--tom, var(--tinta-suave));\r\n  /* O anel garante leitura do estado sem depender apenas da cor. */\r\n  box-shadow: 0 0 0 2px var(--halo, transparent);\r\n}\r\n\r\n.sinal--ok {\r\n  --tom: var(--ok);\r\n  --halo: color-mix(in srgb, var(--ok) 18%, transparent);\r\n}\r\n\r\n.sinal--alerta {\r\n  --tom: var(--alerta);\r\n  --halo: color-mix(in srgb, var(--alerta) 20%, transparent);\r\n}\r\n\r\n.sinal--erro {\r\n  --tom: var(--erro);\r\n  --halo: color-mix(in srgb, var(--erro) 20%, transparent);\r\n  color: var(--erro);\r\n}\r\n\r\n.sinal--neutro {\r\n  --tom: var(--linha-forte);\r\n}\r\n\r\n/* --- Estados de conteúdo ------------------------------------------------- */\r\n\r\n.estado {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-1);\r\n  padding: var(--espaco-3);\r\n  border: 1px dashed var(--linha-forte);\r\n  border-radius: var(--raio);\r\n  background: var(--papel-2);\r\n}\r\n\r\n.estado__titulo {\r\n  font-size: var(--texto-sm);\r\n  font-weight: 600;\r\n}\r\n\r\n.estado__texto {\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-xs);\r\n  line-height: 1.5;\r\n}\r\n\r\n.estado--erro {\r\n  border-style: solid;\r\n  border-color: color-mix(in srgb, var(--erro) 32%, var(--linha));\r\n  background: color-mix(in srgb, var(--erro) 4%, var(--papel));\r\n}\r\n\r\n.estado--erro .estado__titulo {\r\n  color: var(--erro);\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n/* --- Carregamento -------------------------------------------------------- */\r\n\r\n.girando {\r\n  display: inline-block;\r\n  width: 11px;\r\n  height: 11px;\r\n  border: 2px solid var(--linha-forte);\r\n  border-top-color: var(--realce);\r\n  border-radius: 50%;\r\n  animation: girar 700ms linear infinite;\r\n}\r\n\r\n@keyframes girar {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.carregando {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n/* Progresso do carregamento das geometrias, uma requisição por unidade. */\r\n.progresso {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.progresso__barra {\r\n  flex: 1 1 auto;\r\n  height: 2px;\r\n  background: var(--papel-3);\r\n  border-radius: 2px;\r\n  overflow: hidden;\r\n}\r\n\r\n.progresso__preenchimento {\r\n  display: block;\r\n  height: 100%;\r\n  background: var(--pena-unidade);\r\n  transition: width var(--transicao);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
